/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const audioAccounts = (state) => {
  return state.audioAccounts
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getAudioAccountById = (state) => (id) => {
  return state.audioAccounts.find(audioAccount => audioAccount.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  audioAccounts,
  total,
  offset,
  max,
  getAudioAccountById,
  sort,
  order
}
